// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2rw0_","item":"PaymentsMobile_item__1rSOl","label":"PaymentsMobile_label__ue1Gu","amount":"PaymentsMobile_amount__1DeZT"};